const Footer = () => {
  return (
    <footer className="text-center text-muted">Copyright &copy; BlogApp 2025</footer>
  );
};

export default Footer;
